<template>

    <m-edit1/>

    <m-dashboard-layout-2 v-bind='{...{"menuPosition":"store_nav","sideBar":"col-lg-3","contentWrapper":"col-lg-9"},...{}}' :style='""' class="my-2" >
                <template #p-2>   <m-div v-bind='{...{},...{}}' :style='""' class="row mx-auto justify-content-center align-items-top" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col  text-right  " >
                <template #default>   <m-h5 v-bind='{...{},...{}}' :style='"font-size: 13px;\n"' class="my-3 border-bottom pb-2" >
                <template #default>اطلاعات شخصی   </template>
                </m-h5><m-user-profile-1 v-bind='{...{"advanceDescription":false,"advanceDescriptionInputs":"[ { \"name\": \"\u06a9\u062f \u0645\u0644\u06cc\", \"placeholder\": \"\", \"regex\": \"^[0-9]*$\", \"required\": true, \"type\": \"text\" }, { \"name\": \"\u0634\u0645\u0627\u0631\u0647 \u062d\u0633\u0627\u0628\", \"placeholder\": \"\", \"regex\": \"\", \"required\": true, \"type\": \"number\" } ]","loadUserProfile":true},...{}}' :style='""' class=" mx-auto user-profile-500" ></m-user-profile-1></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-12  text-right mt-3" >
                <template #default>   <m-h5 v-bind='{...{},...{}}' :style='"font-size: 13px;\n"' class="my-3 border-bottom pb-3" >
                <template #default>آخرین سفارشات   </template>
                </m-h5><m-orders-1 v-bind='{...{"order_id_prop":true,"user_prop":true,"user_profile_prop":true,"user_description_prop":true,"order_paying_amount_prop":false,"order_paying_status_prop":false,"order_status_prop":false,"order_created_at_prop":false,"order_updated_at_prop":false,"order_transaction_updated_at_prop":false,"actions_prop":false,"order_items_prop":true,"user_cellphone_prop":true,"order_description_prop":true,"dashboardOrders":false},...{}}' :style='""' class="" ></m-orders-1></template>
                </m-div></template>
                </m-div></template>
                </m-dashboard-layout-2>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDashboardLayout2 from '@moeinmdn/miw-alpha-components/src/package/DashboardLayout/DashboardLayout2'; import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mH5 from '@moeinmdn/miw-alpha-components/src/package/Tags/H5'; import mUserProfile1 from '@moeinmdn/miw-alpha-components/src/package/User/Profile/UserProfile1'; import mOrders1 from '@moeinmdn/miw-alpha-components/src/package/Order/Orders1';

export default {
    name: 'HomeView',
    components: {mEdit1, mDashboardLayout2,mDiv,mH5,mUserProfile1,mOrders1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
